import React, { lazy } from 'react';
const LoginComponent = lazy(() => import('./components/LoginComponent'));

export const authConfig = [
	{ 
		component: <LoginComponent />, 
		path: '/', 
		name: 'login', 
		exact: true, 
		auth: false  
	},
];
